export default __webpack_public_path__ + "static/media/trans_convert.7ebcd846.svg";